<template>
  <div>
    <div id="card">
      <!-- 消費記錄 -->
      <div>
        <el-row>
          <el-col :span="24" style="text-align: center;">
            <el-menu style="position: fixed; z-index: 1000; width: 100%; top: 65px;" :default-active="type" class="el-menu-demo" mode="horizontal" @select="handleSelect">
              <el-menu-item index="金額" style="width: 50%;">{{ $t('Store.amount') }}</el-menu-item>
              <el-menu-item index="點數" style="width: 50%;">{{ $t('Store.point') }}</el-menu-item>
            </el-menu>
          </el-col>
        </el-row>
      </div>
      <div v-if="type === '金額'">
        <el-table style="margin: 0 auto; width: 100%; position: fixed; top: 125px; width: 100%;"
          key="table1"
          :height="height"
          :data="consumeList"
          :empty-text="$t('Member.no_comsume')">
          <el-table-column
            width="130"
            prop="Time"
            :label="$t('Member.time')">
            <template slot-scope="scope">
              <span>
                <div style="font-weight: 700;">
                  {{ getDate(scope.row.Time) || $t('Member.no_data') }}
                </div>
                <div style="color: #888;">
                  {{ getTime(scope.row.Time) || $t('Member.no_data') }}
                </div>
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="Store"
            :label="$t('Member.store')">
            <template slot-scope="scope">
              <span>
                <div>
                  {{ (scope.row.Store && scope.row.Store !== 'undefined') ? scope.row.Store : $t('Member.no_data') }}
                </div>
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="Price"
            width="80"
            :label="$t('Member.price')">
            <template slot-scope="scope">
              <span>
                <div style="font-weight: 500; font-size: 15px;" :style="{ color: scope.row.Price < 0 ? red : defaultc }">
                  {{ scope.row.Price || $t('Member.no_data') }}
                </div>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="margin: 0 auto; width: 100%; position: fixed; top: 125px; width: 100%;" v-if="type === '點數'">
        <el-table style="margin: 0 auto; width: 100%;"
          :height="height"
          key="table2"
          :data="AllHistory"
          :empty-text="$t('Member.no_exchange')">
          <el-table-column
            :label="$t('Member.time')"
            width="130">
            <template slot-scope="scope">
              <span>
                <div style="font-weight: 700;">
                  {{ getDate(scope.row.Time) || $t('Member.no_data') }}
                </div>
                <div style="color: #888;">
                  {{ getTime(scope.row.Time) || $t('Member.no_data') }}
                </div>
              </span>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('Member.store')">
            <template slot-scope="scope">
              <span>
                <div>
                  {{ (scope.row.Store && scope.row.Store !== 'undefined') ? scope.row.Store : $t('Member.no_data') }}
                </div>
              </span>
            </template>
          </el-table-column>
          <el-table-column
            width="80"
            :label="$t('Member.point')">
            <template slot-scope="scope">
              <span>
                <div :style="{ color: (scope.row.Point < 0 || getPoint(scope.row.Price) < 0) ? red : green, fontWeight: font, fontSize: size }">
                  {{ scope.row.Price ? getPoint(scope.row.Price) : scope.row.Point }}
                </div>
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="Price"
            :label="$t('Member.remark')">
            <template slot-scope="scope">
              <span>
                <div v-if="scope.row.Type === 'recommend'">推薦</div>
                <div v-else-if="scope.row.Type === 'gift'"><i style="font-size: 20px;" class="el-icon-present"></i></div>
                <div v-else>-</div>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import VueBarcode from 'vue-barcode';
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      type: '金額',
      defaultc: '#666',
      green: '#03b50f',
      red: '#f24',
      font: 500,
      size: '15px'
    };
  },
  props: ['logo', 'ratio', 'service', 'auth', 'id', 'only', 'height'],
  mounted() {
    this.getDetail({ service: this.service, auth: this.auth, token: this.id });
    this.getSend({ service: this.service, auth: this.auth, token: this.id });
    this.getExchange({ service: this.service, auth: this.auth, token: this.id });
  },
  computed: {
    ...mapGetters({
      consumeList: 'consumeList',
      consumeList2: 'consumeList2',
      exchangeList: 'exchangeList',
      sendList: 'sendList'
    }),
    AllHistory() {
      return this.consumeList2.concat(this.exchangeList).concat(this.sendList).sort((a, b) => b.Time - a.Time);
    }
  },
  methods: {
    ...mapActions({
      getSend: 'getSend',
      getDetail: 'getDetail',
      getExchange: 'getExchange',
    }),
    col() {
      if (!this.logo || this.only) {
        return 24;
      }
      return 12;
    },
    OfficialSite() {
      window.open('https://www.eilis-ai.com/');
    },
    getDate(time) {
      return new Date(time).toLocaleDateString();
    },
    getTime(time) {
      return new Date(time).toLocaleTimeString();
    },
    getPoint(price) {
      return parseInt(price / this.ratio);
    },
    handleSelect(key, keyPath) {
      this.type = key;
    },
    refreshData() {
      this.getDetail({ service: this.service, auth: this.auth, token: this.id });
      this.getSend({ service: this.service, auth: this.auth, token: this.id });
      this.getExchange({ service: this.service, auth: this.auth, token: this.id });
    }
  },
}
</script>

<style scoped>
  #card {
    width: 100%;
    max-width: 550px;
    margin: 0 auto;
    overflow: hidden;
    /* box-shadow: 2px 2px 2px 2px rgba(20%, 20%, 20%, 0.3); */
    border-radius: 5px;
    /* position: relative; */
  }
  .web {
    text-decoration: none;
    color: #888;
    transition: 0.2s;
    font-size: 13px;
  }
</style>